import * as React from "react";
import { StaticImageData } from "next/image";

import Multimedia from "@stadium/shared/src/components/shared/multimedia";
import { LinkWithLang } from "components/plasmic/shared/link-with-lang/client";

import { HERO_DEFAULTS, H_04 } from "@stadium/shared/src/helpers/plasmic/static-slices";
import { type LinkWithLangType } from "@stadium/shared/src/constants/stores/routes";

import styles from "./main.module.scss";

export interface H04Props {
  // Content
  heading?: string;
  eyebrow?: string;
  description?: string;

  // CTAs
  primaryButtonText?: string;
  primaryButtonLinkType?: string;
  primaryButtonOpenInNewTab?: boolean;
  primaryButtonOtherUrl?: string;
  primaryButtonCategorySlug?: string;

  image?: string | StaticImageData;
  imageAlt?: string;

  className?: string;
}

const H04: React.FC<Readonly<H04Props>> = ({
  eyebrow = HERO_DEFAULTS[H_04].eyebrow,
  heading = HERO_DEFAULTS[H_04].heading,
  description = HERO_DEFAULTS[H_04].description,
  primaryButtonText = HERO_DEFAULTS[H_04].primaryButtonText,
  primaryButtonLinkType = HERO_DEFAULTS[H_04].primaryButtonLinkType,
  primaryButtonOpenInNewTab = false,
  primaryButtonOtherUrl = HERO_DEFAULTS[H_04].primaryButtonOtherUrl,
  primaryButtonCategorySlug = HERO_DEFAULTS[H_04].primaryButtonCategorySlug,
  imageAlt = HERO_DEFAULTS[H_04].imageAlt,
  image = HERO_DEFAULTS[H_04].image,
  className,
}) => {
  return (
    <section className={`${styles.sectionWrapper} ${className || ""}`}>
      <div className={styles.divWrapper}>
        <div className={styles.contentWrapper}>
          <div className={styles.leftContentWrapper}>
            <div className={styles.leftContent}>
              <p className={styles.eyebrow}>{eyebrow}</p>
              <h1 className={styles.heading}>{heading}</h1>
              {description && <p className={styles.description}>{description}</p>}
              <div className={styles.buttonWrapper}>
                <LinkWithLang
                  type={primaryButtonLinkType as LinkWithLangType}
                  data={{ code: primaryButtonCategorySlug, url: primaryButtonOtherUrl }}
                  target={primaryButtonOpenInNewTab ? "_blank" : "_self"}
                  showExternalLinkIcon={primaryButtonOpenInNewTab}
                  className={styles.primaryBtn}
                >
                  {primaryButtonText}
                </LinkWithLang>
              </div>
            </div>
          </div>

          <div className={styles.rightContent}>
            <Multimedia
              type="image"
              src={image?.url || image}
              alt={imageAlt}
              className={styles.image}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
export default H04;
